import RadioMenuRenderer from './RadioMenuRenderer';
import { initRadio } from './radio';
import './RadioMenuRenderer/radio/Radio.scss';

export const whRadioPlugin = {
  beforeRender: ({ headerRenderers }) => {
    headerRenderers.push(RadioMenuRenderer);

    if (process.env.RUNTIME === 'browser') {
      initRadio();
    }
  },
};
